
import { Actions, ActionTypes } from '@appStore/contracts/actions';
import { ServiceAgreement, ServiceAgreementFilterSettings, ServiceAgreementInformation } from '@model';

export interface State {
    data: ServiceAgreement[]
    loading: boolean;
    loaded: boolean;
    selected: ServiceAgreementInformation;

    serviceAgreementsFilter: ServiceAgreementFilterSettings;

    // Pagination and sorting state
    selectedPageIndex: number,
    selectedPageSize: number,
    sortColumn: string,
    sortDirection: string,
    scrollPosition: [number, number]
}

export const initialState: State = {
    data: [],
    loading: false,
    loaded: false,
    selected: null,

    serviceAgreementsFilter: null,

    // Pagination and sorting state
    selectedPageIndex: 0,
    selectedPageSize: 25,
    sortColumn: 'agreementId',
    sortDirection: 'desc',
    scrollPosition: [0, 0]
};

export function reducer(state = initialState, action: Actions): State {
  switch (action.type) {
    case ActionTypes.ServiceAgreementsLoad:
      return { ...state, loaded: false, loading: true };

    case ActionTypes.ServiceAgreementsLoadSuccess:
      return {
        ...state,
        loaded: true,
        loading: false,
        data: action.payload
      };

    case ActionTypes.ServiceAgreementsLoadFail:
      return { ...state, loaded: false, loading: false };

    // Filter
    case ActionTypes.ServiceAgreementsFilterSaveData:
      return { ...state, serviceAgreementsFilter: action.payload };  

    case ActionTypes.SelectServiceAgreement:
        return {...state, selected: action.payload };    
    case ActionTypes.SelectServiceAgreementById:
      let sai = null;
      state.data.forEach(e => {
        e.serviceAgreementInformation.forEach(sa => {
          if (sa.agreementId === action.payload) {
            sai = {...sa,
              customerId: e.customerId
            }; 
          }
        });
      });
      return { ...state, selected: sai }; 
    case ActionTypes.ServiceAgreementsSelectedPageIndex:
      return {
        ...state,
        selectedPageIndex: action.pageIndex,
        selectedPageSize: action.pageSize,
        sortColumn: action.sortColumn,
        sortDirection: action.sortDirection,
        scrollPosition: action.scrollPosition
      };
  }
  return state;
}

export const getServiceAgreementsLoaded = (state: State) => state.loaded;
export const getServiceAgreements = (state: State) => state.data;
export const getServiceAgreementsFilter = (state: State) => state.serviceAgreementsFilter;
export const getSelectedServiceAgreement = (state: State) => state.selected;
export const getServiceAgreementsFilterSettings = (state: State) => state.serviceAgreementsFilter;
export const _getSelectedPageIndex = (state: State) => {
  return {
    pageIndex: state.selectedPageIndex,
    pageSize: state.selectedPageSize,
    sortDirection: state.sortDirection,
    sortColumn: state.sortColumn,
    scrollPosition: state.scrollPosition
  };
};
  